import React from 'react';
import { NavLink } from 'react-router-dom';
import { Tab } from './tabStyles';

type Props = {
	children?: React.ReactNode;
	href: string;
};

const CustomTabBtn: React.FC<Props> = ({ children, href }) => {
	return (
		<Tab>
			<NavLink to={href}>{children}</NavLink>
		</Tab>
	);
};

export default CustomTabBtn;
